import { Component, OnInit, NgZone } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { environment } from '../../../../../environments/environment';
import { AuthservicesService } from '../../../../services/authservices.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { MustMatch } from '../../../shared/utils/dateValidator.validator'
import * as moment from 'moment';
declare const google: any;
declare module 'googlemaps';
@Component({
  selector: 'app-edit-events',
  templateUrl: './edit-events.component.html',
  styleUrls: ['./edit-events.component.css']
})
export class EditEventsComponent implements OnInit {
  form: FormGroup;
  customCategory: FormArray;
  submitted = false
  errorMessage
  model: NgbDateStruct;
  modelSecond: NgbDateStruct
  datesArray = [];
  hourArray = []
  gallaryArr = []
  loading = false;
  selectedItem
  eventImage = ''
  closeResult = '';
  showImage = false
  showDays = false;
  showhours = false
  notifyAttendersValue = false;
  notifyvisitorsValue = false
  eventId
  allAddress = ""
  productData
  address
  constructor(private route: ActivatedRoute, private authService: AuthservicesService, private modalService: NgbModal, private fb: FormBuilder, private router: Router, private zone: NgZone) {

    // const today: string = moment().format('D MMM YYYY');

    // console.log(today)
  }
  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.eventId = params["id"];
    });

    this.getGallary();
    this.getEventDetails()

    this.errorMessage = environment.errorMessage
    this.form = this.fb.group({
      eventName: ['', Validators.required],
      description: ['', Validators.required],
      validFrom: ['', Validators.required],
      locationName: [''],
      validTill: ['', Validators.required],
      photo: ['', Validators.required],
      address: ['', Validators.required],
      notifyVisitors: [false],
      notifyAttenders: [false],
      notifyVisitorsBefore: [''],
      notifyAttenderBefore: [''],
      accessibility: ['', Validators.required]
    },
      {
        validator: MustMatch('validFrom', 'validTill')
      })
  }
  get f() {
    return this.form.controls;
  }




  open(content) {
    this.showImage = false
    this.modalService.open(content, { centered: true }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    this.showImage = true;
    this.eventImage = this.productData['photo']
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }


  onSubmit() {
    this.submitted = true;
    if (this.form.invalid) {
      this.authService.scrollToError();
      return;
    }

    this.authService.editEvent(this.form.value,this.productData['_id']).subscribe((res: any) => {
      this.messageAlert(res.message, 'success')
      this.router.navigate(['/event-manager'])

    },
      error => {
        this.messageAlert(error.error.message, 'error')
      })
  }
  selectImage(props, index) {

    this.selectedItem = index;
    this.eventImage = props.url

  }
  getGallary() {
    this.authService.galleryApi(0, 10).subscribe((res: any) => {
      this.loading = true
      this.gallaryArr = res.items

    },
      error => {
        console.log(error)
      })
  }

  getEventDetails() {
    this.authService.getEventsById(this.eventId).subscribe((res: any) => {
      this.loading = true
      this.productData = res.data;
      const CONTROL = this.form.controls;
      this.address = this.productData['address']['streetAddress'];
      for (const props in CONTROL) {
        CONTROL[props].patchValue(this.productData[props]);

        if (props == "photo") {
          this.showImage = true
          this.eventImage = this.productData['photo'];
        }
        if (props == 'validFrom' || props == 'validTill') {
          let format = moment(this.productData[props]).format('L');
          this.form.get(props).setValue(format)
          console.log(format)
        }

      

      }


    },
      error => {
        console.log(error)
      })
  }

  check(event, type) {
    if (event.target.checked && (type == 'visitors' || type == 'attendees')) {
      this.findDiff(type)
    }


    else {
      this.showhours = false
      this.showDays = false;
    }

  }


  addimageForm() {
    this.showImage = true
    this.form.get('photo').setValue(this.eventImage)
  }



  findDiff(type) {
    if (this.model && this.modelSecond) {
      this.hourArray = []
      let diffdate = moment(this.modelSecond).diff(moment(this.model), 'days')
      if (type == "attendees") {
        this.notifyAttendersValue = true
        this.hourArray = []
        this.showhours = true
        this.form.get('notifyAttenders').setValue(true)

        if (diffdate == 0) {
          this.hourArray.push(1)
        }
        else if (diffdate != 0) {
          diffdate = 24
          for (let i = 0; i < diffdate; i++) {
            this.hourArray.push(i + 1)
          }
        }

      }
      else if (type == 'visitors') {
        this.datesArray = []
        this.showDays = true
        this.form.get('notifyVisitors').setValue(true)
        if (diffdate == 0) {
          this.datesArray.push(1)
        }
        else if (diffdate != 0) {
          for (let i = 0; i < diffdate; i++) {
            this.datesArray.push(i + 1)
            this.showDays = true

          }
        }
      }
    }
  }

  AddressChange(address: any, ) {
    let obj = {
      streetAddress: "",
      city: "",
      location: "",
      state: "",
      googleAddress: "",
      postalCode: "",
      country: "",
      suite_no: "",
      landMark: ""
    }
    this.zone.run(() => {
      this.createArray(address, obj)
    }
    )
  }

  createArray(address, addressobj) {
    let latitude = address.geometry.location.lat();
    let longitude = address.geometry.location.lng();

    // this.form.get('addressName').setValue(address.formatted_address),
    addressobj['streetAddress'] = address.formatted_address
    addressobj['googleAddress'] = (address.name) ? address.name : ''
    addressobj['location'] = { "type": "Point", "coordinates": [longitude, latitude] }

    let address_components = address.address_components;
    for (let i = 0; i < address_components.length; i++) {
      if (address_components[i].types[0] == 'administrative_area_level_2') {
        addressobj['city'] = address_components[i].long_name || '';
      } else if (address_components[i].types[0] == 'administrative_area_level_1') {
        addressobj['state'] = address_components[i].long_name || '';
      } else if (address_components[i].types[0] == 'country') {
        addressobj['country'] = address_components[i].long_name || '';
      } else if (address_components[i].types[0] == 'postal_code') {
        addressobj['postalCode'] = address_components[i].long_name || '';
      }
    }

    // this.allAddress = `${addressobj.streetAddress}`

    this.form.get('address').setValue(addressobj)


  }



  messageAlert(message, type) {
    this.authService.successMessage(message, type)
  }


  loaded(event, className) {
    this.authService.loadImage(event, className)
  }


  getErrorImage(event) {
    this.authService.geterrorImage(event);

  }

}

